export default class HandoverSessionPackageInfo{
    deliveryPackageId :number;
    packageNo:string;
    refTypeCode :string;
    refCode : string;
    externalCode:string;
    tplCode:string;
    clientCode:string;
    numOfPackages:number;
    orderPackage:string;
    completed:boolean;
    order: number;
    handoverTime:Date;
    canDelete: boolean;
    customerId:number;
    customerName:string;
    tplName:string;
    clientName:string;
    refTypeName:string;
}